export default {
    holidayToEdit: (state) => {
        return state.holidayToEdit;
    },
}